import Phaser from "phaser";
import ProgressBar from "./ProgressBar";
import Tracking from "./Tracking";
import Pqp from "../../3x1010/Pqp";
import CheckOptions from "./CheckOption";
import PlayPause from "./PlayPause";
import MainScene from "./MainScene";
import FullscreenOnOff from "./FullscreenOnOff";
import TagVelocity from "./TagVelocity";
import Locale from "../../3x1010/Locale";

export default class UiInterface extends Phaser.GameObjects.Container {
  constructor(scene, callback) {
    super(scene);
    this.callback = callback;
    UiInterface.that = this;
  }

  init() {
    this.createBackground();
    this.createProgressBar();
    this.createSeekTime();
    this.createVisualOptions();
    this.createPlayPause();
    this.createFullscreenOnOff();
    this.createPhaseInfo();
    this.createTagVelocity();
    //this.createHtAnalisi();
    this.createVersion();
    this.createDisabler();
  }

  createPlayPause() {
    this.playPause = new PlayPause(this.scene, this.handlePlayPauseEvents.bind(this));
    this.playPause.init(false);
    this.add(this.playPause);
    this.playPause.x = UiInterface.PLAY_PAUSE_X;
    this.playPause.y = UiInterface.BAR_LOWER_Y;

    const vbar = this.createVbar(true);
    this.add(vbar);
    vbar.x = this.playPause.x + 24;
    vbar.y = UiInterface.BAR_LOWER_Y - Math.floor(UiInterface.VBAR_HEIGHT_LOW / 2);
  }

  createFullscreenOnOff() {
    this.fullOnOff = new FullscreenOnOff(this.scene);
    this.fullOnOff.init(false);
    this.add(this.fullOnOff);
    this.fullOnOff.x = UiInterface.FULL_ON_OFF_X;
    this.fullOnOff.y = UiInterface.BAR_LOWER_Y;

    const vbar = this.createVbar(true);
    this.add(vbar);
    vbar.x = this.fullOnOff.x - 32;
    vbar.y = UiInterface.BAR_LOWER_Y - Math.floor(UiInterface.VBAR_HEIGHT_LOW / 2);
  }

  setPlayPause(flag) {
    this.playPause.setPlay(flag);
  }

  handlePlayPauseEvents(e) {
    if (e.type === PlayPause.EVENT_CHANGED) {
      if (e.data) {
        this.dispatch(UiInterface.EVENT_RESUME);
      } else {
        this.dispatch(UiInterface.EVENT_PAUSE);
      }
    }
  }

  createProgressBar() {
    //const w = Math.floor(Tracking.WIDTH * UiInterface.PROGRESS_BAR_WIDTH_PERCENT);
    //console.log(Tracking.data[2]);
    const w = Math.floor(UiInterface.PROGRESS_BAR_WIDTH);

    const barBack = this.scene.add.rectangle(0, UiInterface.BAR_Y, Tracking.WIDTH, UiInterface.BAR_THICKNESS, ProgressBar.COLOR_BACK);
    barBack.setOrigin(0, 0);
    this.add(barBack);

    for (let x = 0; x < 2; x++) {
      const vbar = this.createVbar();
      this.add(vbar);
      if (x === 0) {
        vbar.x = Math.floor((Tracking.WIDTH - w) / 2) - UiInterface.BAR_THICKNESS;
      } else {
        vbar.x = Math.floor((Tracking.WIDTH - w) / 2) + w + UiInterface.BAR_THICKNESS / 2;
      }
      vbar.y = UiInterface.BAR_Y - Math.floor(UiInterface.VBAR_HEIGHT / 2);
    }

    this.progressBar = new ProgressBar(this.scene, w, MainScene.that.dataSelected.data[2], MainScene.that.dataSelected.data[3], this.handleProgressBarEvents.bind(this));
    this.progressBar.init();
    this.add(this.progressBar);
    this.progressBar.x = Math.floor((Tracking.WIDTH - w) / 2);
    this.progressBar.y = UiInterface.BAR_Y;
  }

  createVbar(lower = false) {
    let h = UiInterface.VBAR_HEIGHT;
    if (lower) {
      h = UiInterface.VBAR_HEIGHT_LOW;
    }
    const vbar = this.scene.add.rectangle(0, 0, UiInterface.BAR_THICKNESS, h, ProgressBar.COLOR_BACK);
    vbar.setOrigin(0, 0);
    return vbar;
  }

  createSeekTime() {
    //console.log();
    const txt = this.scene.add.text(this.progressBar.x + this.progressBar.barWidth + 8, 28, "", { fontFamily: "DIN Next LT Pro", fontSize: "24px", color: this.toHexColor(ProgressBar.COLOR_BACK) });
    this.add(txt);
    this.txtTime = txt;

    const txtSeek = this.scene.add.text(this.progressBar.x + this.progressBar.barWidth + 8, 58, "", { fontFamily: "DIN Next LT Pro", fontSize: "24px", color: this.toHexColor(ProgressBar.COLOR_2) });
    this.add(txtSeek);
    this.txtTimeSeek = txtSeek;
    this.hideTimeSeekTo();
  }

  toHexColor(num) {
    let s = num.toString(16);
    while (s.length < 6) {
      s = "0" + s;
    }
    return "#" + s;
  }

  createVisualOptions() {
    const vbar = this.createVbar(true);
    this.add(vbar);
    vbar.x = UiInterface.START_CHECK - 46;
    vbar.y = UiInterface.BAR_LOWER_Y - Math.floor(UiInterface.VBAR_HEIGHT_LOW / 2);

    // Video
    this.optionShowVideo = new CheckOptions(this.scene, Locale.g("video"), this.handleShowVideoEvents.bind(this));
    this.optionShowVideo.init(true);
    this.optionShowVideo.x = UiInterface.START_CHECK;
    this.optionShowVideo.y = UiInterface.BAR_LOWER_Y;
    this.add(this.optionShowVideo);
    this.checkShowVideo();
    // Bounding box
    /*this.optionShowBound = new CheckOptions(this.scene, "BOX ", this.handleShowBoundEvents.bind(this), 8);
    this.optionShowBound.init(false);
    this.optionShowBound.x = this.optionShowVideo.x + this.optionShowVideo.getWidth() + 12;
    this.optionShowBound.y = UiInterface.BAR_LOWER_Y;
    this.add(this.optionShowBound);
    this.checkShowBound();*/
    // Manequin
    /*this.optionShowManequin = new CheckOptions(this.scene, "BONES ", this.handleShowManequinEvents.bind(this));
    this.optionShowManequin.init(true);
    this.optionShowManequin.x = this.optionShowBound.x + this.optionShowBound.getWidth() + 12;
    this.optionShowManequin.y = UiInterface.BAR_LOWER_Y;
    this.add(this.optionShowManequin);
    this.checkShowManequin();*/

    this.optionShowManequin = new CheckOptions(this.scene, Locale.g("lines"), this.handleShowManequinEvents.bind(this));
    this.optionShowManequin.init(true);
    this.optionShowManequin.x = this.optionShowVideo.x + this.optionShowVideo.getWidth() + 12;
    this.optionShowManequin.y = UiInterface.BAR_LOWER_Y;
    this.add(this.optionShowManequin);
    this.checkShowManequin();

    // Stats
    this.optionShowStats = new CheckOptions(this.scene, Locale.g("info"), this.handleShowStatsEvents.bind(this));
    this.optionShowStats.init(true);
    this.optionShowStats.x = this.optionShowManequin.x + this.optionShowManequin.getWidth() + 12;
    this.optionShowStats.y = UiInterface.BAR_LOWER_Y;
    this.add(this.optionShowStats);
    this.checkShowStats();

    // Prestazioni
    this.optionPerformance = new CheckOptions(this.scene, Locale.g("qualityMax"), this.handlePerformanceEvents.bind(this), -24);
    this.optionPerformance.init(true);
    this.optionPerformance.x = vbar.x - this.optionPerformance.getWidth() - 12;
    this.optionPerformance.y = UiInterface.BAR_LOWER_Y;
    this.add(this.optionPerformance);
    this.checkPerformance();

    const vbar2 = this.createVbar(true);
    this.add(vbar2);
    vbar2.x = this.optionPerformance.x - 44;
    vbar2.y = UiInterface.BAR_LOWER_Y - Math.floor(UiInterface.VBAR_HEIGHT_LOW / 2);
  }

  handlePerformanceEvents(e) {
    if (e.type === CheckOptions.EVENT_CHANGED) {
      this.checkPerformance();
    }
  }

  checkPerformance() {
    this.dispatch(UiInterface.EVENT_PERFORMANCE, this.optionPerformance.checked);
  }

  handleShowVideoEvents(e) {
    if (e.type === CheckOptions.EVENT_CHANGED) {
      this.checkShowVideo();
    }
  }

  checkShowStats() {
    this.dispatch(UiInterface.EVENT_SHOW_STATS, this.optionShowStats.checked);
  }

  handleShowStatsEvents(e) {
    if (e.type === CheckOptions.EVENT_CHANGED) {
      this.checkShowStats();
    }
  }

  checkShowVideo() {
    this.dispatch(UiInterface.EVENT_SHOW_VIDEO, this.optionShowVideo.checked);
  }

  handleShowBoundEvents(e) {
    if (e.type === CheckOptions.EVENT_CHANGED) {
      this.checkShowBound();
    }
  }

  checkShowBound() {
    this.dispatch(UiInterface.EVENT_SHOW_BOUND, this.optionShowBound.checked);
  }

  handleShowManequinEvents(e) {
    if (e.type === CheckOptions.EVENT_CHANGED) {
      this.checkShowManequin();
    }
  }

  checkShowManequin() {
    this.dispatch(UiInterface.EVENT_SHOW_MANEQUIN, this.optionShowManequin.checked);
  }

  setBar(perc, time) {
    this.progressBar.setBar(perc);
    this.updateTime(time);
  }

  convTime(time) {
    /*    console.log(time);
    let ms = "" + parseInt((time - parseInt(time)) * 1000);
    //console.log(ms);
    if (ms.length === 1) {
      ms = "00" + ms;
    } else if (ms.length === 2) {
      ms = "0" + ms;
    }

    //console.log(ms);
    const min = Math.floor(parseInt(time) / 60);
    const sec = parseInt(time) - min * 60;

    return Pqp.padr("" + min, "0", 2) + ":" + Pqp.padr("" + sec, "0", 2) + "." + ms;*/
    let ms = time - parseInt(time);
    ms = ms.toFixed(3);
    ms = "" + ms;
    ms = ms.substring(2);
    //console.log(ms);

    //console.log(ms);
    const min = Math.floor(parseInt(time) / 60);
    const sec = parseInt(time) - min * 60;

    const value = Pqp.padr("" + min, "0", 2) + ":" + Pqp.padr("" + sec, "0", 2) + "." + ms;
    //console.log(value);
    return value;
  }

  updateTime(time) {
    // Aggiorna anche il numero del fotogramma
    const frame = Math.round(time * MainScene.FPS);

    this.txtTime.setText(this.convTime(time) + "   /   " + frame);

    // Agggiorna anche la phases
    let phase = this.getPhase(time);
    if (!Pqp.isNullOrEmpty(phase)) {
      phase = Locale.g(phase);
    }
    this.txtPhase.setText(phase.toUpperCase());
    //this.txtPhase.setText(phase.toLowerCase());
  }

  showTimeSeekTo(perc) {
    this.txtTimeSeek.visible = true;
    const total = MainScene.that.vid.getDuration();
    const actual = total * perc;

    const frame = Math.round(actual * MainScene.FPS);
    this.txtTimeSeek.setText(this.convTime(actual) + "   /   " + frame);
  }

  hideTimeSeekTo() {
    this.txtTimeSeek.visible = false;
  }

  getPhase(time) {
    const t = time * 1000;
    const a = MainScene.that.dataSelected.data[2];
    let label = "";
    for (let x = 0; x < a.length; x++) {
      if (t >= a[x].time) {
        ({ label } = a[x]);
      }
    }
    return label;
  }

  createBackground() {
    const graphics = this.scene.add.graphics();
    graphics.fillGradientStyle(0x152ba0, 0x152ba0, 0x152ba0, 0x152ba0, 0.3, 0.3, 0.3, 0.3);
    graphics.fillRect(0, 0, Tracking.WIDTH, UiInterface.HEIGHT);
    this.add(graphics);

    //

    /*const back = this.scene.add.rectangle(0, 128, Tracking.WIDTH, 64, 0x162ca1);
    back.alpha = 0.8;
    back.setOrigin(0, 0);
    this.add(back);*/

    const back = this.scene.add.graphics();
    back.fillGradientStyle(0x152ba0, 0x152ba0, 0x152ba0, 0x152ba0, 0.8, 0.8, 0.8, 0.8);
    back.fillRect(0, 128, Tracking.WIDTH, 64);
    back.setBlendMode(Phaser.BlendModes.MULTIPLY);
    this.add(back);

    const line = this.scene.add.rectangle(0, 118, Tracking.WIDTH, 10, ProgressBar.COLOR_FRONT);
    line.setOrigin(0, 0);
    this.add(line);
    this.scene.plugins.get("rexDropShadowPipeline").add(line, UiInterface.DROP_SHADOW);

    graphics.setInteractive(new Phaser.Geom.Rectangle(0, 0, Tracking.WIDTH, UiInterface.HEIGHT), Phaser.Geom.Rectangle.Contains);
  }

  handleProgressBarEvents(e) {
    if (e.type === ProgressBar.EVENT_PAUSE) {
      this.dispatch(UiInterface.EVENT_PAUSE);
    } else if (e.type === ProgressBar.EVENT_RESUME) {
      this.dispatch(UiInterface.EVENT_RESUME);
    } else if (e.type === ProgressBar.EVENT_MOVED_KNOB) {
      this.dispatch(UiInterface.EVENT_MOVED_KNOB, e.data);
    } else if (e.type === ProgressBar.EVENT_SHOW_TIME_TO_SEEK_TO) {
      this.showTimeSeekTo(e.data);
    } else if (e.type === ProgressBar.EVENT_HIDE_TIME_TO_SEEK_TO) {
      this.hideTimeSeekTo();
    }
  }

  dispatch(type, data) {
    if (this.callback) {
      const e = { type };
      if (!Pqp.isNullOrEmpty(data)) {
        e.data = data;
      }
      this.callback.call(null, e);
    }
  }

  createPhaseInfo() {
    const txt = this.scene.add.text(0, 0, "", { fontFamily: "DIN Next LT Pro", fontSize: "40px", color: this.toHexColor(ProgressBar.COLOR_BACK), align: "center", fixedWidth: Tracking.WIDTH });
    this.add(txt);
    this.txtPhase = txt;
    txt.y = UiInterface.BAR_LOWER_Y - txt.height / 2;
  }

  createTagVelocity() {
    const x1 = new TagVelocity(this.scene, 0, "X 1", this.handleTagVelocity.bind(this));
    x1.init();
    this.add(x1);
    x1.x = UiInterface.VELOCITY_TAG_X;
    x1.y = UiInterface.BAR_LOWER_Y - x1.h / 2;
    x1.setActive(true);
    this.tagx1 = x1;

    const x5 = new TagVelocity(this.scene, 1, "X 0.5", this.handleTagVelocity.bind(this));
    x5.init();
    this.add(x5);
    x5.x = UiInterface.VELOCITY_TAG_X + x1.w + 16;
    x5.y = UiInterface.BAR_LOWER_Y - x5.h / 2;
    this.tagx5 = x5;

    const x10 = new TagVelocity(this.scene, 2, "X 0.1", this.handleTagVelocity.bind(this));
    x10.init();
    this.add(x10);
    x10.x = x5.x + x5.w + 16;
    x10.y = UiInterface.BAR_LOWER_Y - x10.h / 2;
    this.tagx10 = x10;

    const vbar = this.createVbar(true);
    this.add(vbar);
    vbar.x = x10.x + x10.w + 16;
    vbar.y = UiInterface.BAR_LOWER_Y - Math.floor(UiInterface.VBAR_HEIGHT_LOW / 2);

    // Next e Prev

    const prev = this.scene.add.text(0, 0, Locale.g("previous"), { fontFamily: "DIN Next LT Pro", fontSize: "24px", color: this.toHexColor(ProgressBar.COLOR_BACK) });
    this.add(prev);
    prev.x = vbar.x + 16;
    prev.y = UiInterface.BAR_LOWER_Y - prev.height / 2;
    prev.setInteractive({ useHandCursor: true });
    prev.on("pointerdown", () => {
      //this.dispatch(UiInterface.EVENT_RESUME);
      MainScene.that.pauseVideo();
      this.progressBar.prevFrame();
    });

    const vbar2 = this.createVbar(true);
    this.add(vbar2);
    vbar2.x = prev.x + prev.width + 16;
    vbar2.y = UiInterface.BAR_LOWER_Y - Math.floor(UiInterface.VBAR_HEIGHT_LOW / 2);

    const next = this.scene.add.text(0, 0, Locale.g("next"), { fontFamily: "DIN Next LT Pro", fontSize: "24px", color: this.toHexColor(ProgressBar.COLOR_BACK) });
    this.add(next);
    next.x = vbar2.x + 16;
    next.y = UiInterface.BAR_LOWER_Y - next.height / 2;
    next.setInteractive({ useHandCursor: true });
    next.on("pointerdown", () => {
      //this.dispatch(UiInterface.EVENT_RESUME);
      MainScene.that.pauseVideo();
      this.progressBar.nextFrame();
    });

    // Aggiunge il controllo da tastiere per next e prev
    this.scene.input.keyboard.on("keydown", (e) => {
      if (e.key === "ArrowLeft") {
        MainScene.that.pauseVideo();
        this.progressBar.prevFrame();
      } else if (e.key === "ArrowRight") {
        MainScene.that.pauseVideo();
        this.progressBar.nextFrame();
      }
    });

    const vbar3 = this.createVbar(true);
    this.add(vbar3);
    vbar3.x = next.x + next.width + 16;
    vbar3.y = UiInterface.BAR_LOWER_Y - Math.floor(UiInterface.VBAR_HEIGHT_LOW / 2);
  }

  handleTagVelocity(e) {
    if (e.type === TagVelocity.EVENT_CLICKED) {
      this.tagx1.setActive(false);
      this.tagx5.setActive(false);
      this.tagx10.setActive(false);
      if (e.data === 0) {
        this.tagx1.setActive(true);
        this.dispatch(UiInterface.EVENT_GOX1);
      } else if (e.data === 1) {
        this.tagx5.setActive(true);
        this.dispatch(UiInterface.EVENT_GOX5);
      } else {
        this.tagx10.setActive(true);
        this.dispatch(UiInterface.EVENT_GOX10);
      }
    }
  }

  setNormalMode() {
    this.disabler.visible = false;
    this.progressBar.showPoints();
    this.playPause.enable(true);
  }

  setSlowedMode() {
    this.disabler.visible = true;
    this.progressBar.hidePoints();
    this.playPause.enable(false);
    if (!this.playPause.isPlaying) {
      this.playPause.toggleState();
    }
  }

  createDisabler() {
    const rect = this.scene.add.rectangle(0, 0, Tracking.WIDTH, 118, ProgressBar.COLOR_FRONT);
    rect.setOrigin(0, 0);
    rect.alpha = 0.00001;
    this.add(rect);
    rect.setInteractive(new Phaser.Geom.Rectangle(0, 0, Tracking.WIDTH, 118), Phaser.Geom.Rectangle.Contains);
    this.disabler = rect;
    this.disabler.visible = false;
  }

  createHtAnalisi() {
    // ht analisi
    this.optionShowAnalisi = new CheckOptions(this.scene, "         ANALISI", this.handleShowAnalisiEvents.bind(this));
    this.optionShowAnalisi.init(false);
    this.optionShowAnalisi.x = UiInterface.ANALISI_X;
    this.optionShowAnalisi.y = UiInterface.BAR_LOWER_Y;
    this.add(this.optionShowAnalisi);
    //this.optionShowAnalisi.alpha = 0.4;
    //this.optionShowAnalisi.removeInteractive();
    //this.checkShowManequin();
    // Immagine
    const logo = this.scene.add.image(0, 0, "logosmall");
    //logo.alpha = 0.4;
    //    logo.setOrigin(0, 0);
    this.add(logo);
    logo.x = UiInterface.ANALISI_X + 22; //- logo.width - 16;
    logo.y = UiInterface.BAR_LOWER_Y;

    const vbar = this.createVbar(true);
    this.add(vbar);
    vbar.x = UiInterface.ANALISI_X + 114;
    vbar.y = UiInterface.BAR_LOWER_Y - Math.floor(UiInterface.VBAR_HEIGHT_LOW / 2);
  }

  handleShowAnalisiEvents(e) {
    if (e.type === CheckOptions.EVENT_CHANGED) {
      this.checkShowAnalisi();
    }
  }

  checkShowAnalisi() {
    this.dispatch(UiInterface.EVENT_SHOW_ANALISI, this.optionShowAnalisi.checked);
  }

  createVersion() {
    //console.log(Tracking.data);

    const txt = this.scene.add.text(0, UiInterface.BAR_LOWER_Y - 10, Tracking.data.version, { fontFamily: "DIN Next LT Pro", fontSize: "20px", color: this.toHexColor(ProgressBar.COLOR_BACK) });
    txt.x = Tracking.WIDTH - txt.width - 20;
    this.add(txt);
  }
}

//UiInterface.PROGRESS_BAR_WIDTH_PERCENT = 0.75;
//UiInterface.PROGRESS_BAR_WIDTH = 1288;
UiInterface.PROGRESS_BAR_WIDTH = 1600;
UiInterface.HEIGHT = 192;

UiInterface.EVENT_PAUSE = "eventPause";
UiInterface.EVENT_RESUME = "eventResume";
UiInterface.EVENT_MOVED_KNOB = "eventMovedKnob";

UiInterface.EVENT_SHOW_VIDEO = "eventShowVideo";
UiInterface.EVENT_SHOW_BOUND = "eventShowBound";
UiInterface.EVENT_SHOW_MANEQUIN = "eventShowManequin";
UiInterface.EVENT_PERFORMANCE = "eventPerformance";
UiInterface.EVENT_SHOW_STATS = "eventStats";

UiInterface.DROP_SHADOW = {
  // ** Offset **
  // rotation:
  angle: -90, // degrees
  distance: 1,
  // ** Shadow color **
  shadowColor: 0x000000,
  alpha: 0.25,
  //shadowOnly: false,
  // ** Parameters of KawaseBlur **
  blur: 2,
  //quality: 3,
  pixelWidth: 1,
  pixelHeight: 1,
  // name: 'rexDropShadowPostFx'
};

UiInterface.BAR_Y = 55;
UiInterface.BAR_LOWER_Y = 160;
UiInterface.VBAR_HEIGHT = 44;
UiInterface.VBAR_HEIGHT_LOW = 36;
UiInterface.BAR_THICKNESS = 2;
UiInterface.PLAY_PAUSE_X = 124 + 64 + 64;
UiInterface.VELOCITY_TAG_X = 168 + 64 + 64;
UiInterface.FULL_ON_OFF_X = 1796;
//UiInterface.START_CHECK = 1520;
UiInterface.START_CHECK = 1430 + 72 + 28; // + 100;

UiInterface.EVENT_GOX1 = "eventGox1";
UiInterface.EVENT_GOX5 = "eventGox5";
UiInterface.EVENT_GOX10 = "eventGox10";
UiInterface.ANALISI_X = 354;
